export default function BriefForm($form) {

    var $price = $form.find('.js-price');

    $form.find('.js-radio').on('change', function(e) {

        var $radio = $(e.target),
            price = new Intl.NumberFormat().format($radio.data('price'));

        $price.text(price);
    });
}